import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';

// Pages
import LandingPage from './pages/LandingPage';
import ReviewFunnel from './pages/ReviewFunnel';
import ReviewEdit from './pages/ReviewEdit';
import HVLogin from './pages/HVLogin';
import HVDashboard from './pages/HVDashboard';
import HVLinks from './pages/HVLinks';
import HVLinkDetail from './pages/HVLinkDetail';
import HVReviews from './pages/HVReviews';
import HVSettings from './pages/HVSettings';
import HVBilling from './pages/HVBilling';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminTenants from './pages/AdminTenants';
import AdminTenantDetail from './pages/AdminTenantDetail';
import AdminReviews from './pages/AdminReviews';
import AdminPrompts from './pages/AdminPrompts';
import AdminMetaScores from './pages/AdminMetaScores';
import AdminCoupons from './pages/AdminCoupons';
import LegalPage from './pages/LegalPage';
import AuthVerify from './pages/AuthVerify';
import NotFound from './pages/NotFound';
import ContactPage from './pages/ContactPage';
import OnboardingPage from './pages/OnboardingPage';

import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation;

  return (
    <>
      {/* Main routes — when login overlay is open, keep landing page mounted */}
      <Routes location={backgroundLocation || location}>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/impressum" element={<LegalPage />} />
        <Route path="/datenschutz" element={<LegalPage />} />
        <Route path="/agb" element={<LegalPage />} />
        <Route path="/ki-transparenz" element={<LegalPage />} />
        <Route path="/barrierefreiheit" element={<LegalPage />} />
        <Route path="/bildnachweise" element={<LegalPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/r/:tenantSlug/:linkSlug" element={<ReviewFunnel />} />
        <Route path="/r/edit" element={<ReviewEdit />} />

        {/* HV Auth */}
        <Route path="/app/login" element={<HVLogin />} />
        <Route path="/app/auth/verify" element={<AuthVerify type="hv" />} />

        {/* HV Dashboard */}
        <Route path="/app" element={<HVDashboard />} />
        <Route path="/app/links" element={<HVLinks />} />
        <Route path="/app/links/:linkId" element={<HVLinkDetail />} />
        <Route path="/app/reviews" element={<HVReviews />} />
        <Route path="/app/settings/:section" element={<HVSettings />} />
        <Route path="/app/settings" element={<HVSettings />} />
        <Route path="/app/billing" element={<HVBilling />} />

        {/* Admin Auth */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/auth/verify" element={<AuthVerify type="admin" />} />

        {/* Admin Dashboard */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/tenants" element={<AdminTenants />} />
        <Route path="/admin/tenants/:tenantId" element={<AdminTenantDetail />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
        <Route path="/admin/prompts" element={<AdminPrompts />} />
        <Route path="/admin/meta-scores" element={<AdminMetaScores />} />
        <Route path="/admin/coupons" element={<AdminCoupons />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Modal overlays — rendered on top of background location */}
      {backgroundLocation && (
        <Routes>
          <Route path="/app/login" element={<HVLogin overlay />} />
          <Route path="/onboarding" element={<OnboardingPage overlay />} />
        </Routes>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <div className="App">
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
